// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"415375ca","239":"5cc580f9","389":"da365b6c","732":"26319390","977":"a73df6ea"}[chunkId] + ".chunk.js";
};